module.exports = __webpack_public_path__ + "img/icone_filtrodebusca.fd577e8c.svg";